import workFlow from './work-flow'
import workTemplate from './work-template'

export default [
  // 工单流程
  ...workFlow,
  // 工单模板
  ...workTemplate
]
